import { LogIn } from "lucide-react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center px-6">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-surface/60 p-10 text-center">
        <h1 className="font-display text-3xl font-bold uppercase tracking-tight text-white">
          DJ <span className="text-gold">Código</span>
        </h1>
        <p className="mt-2 text-xs font-semibold uppercase tracking-[0.3em] text-gold">Admin</p>
        <p className="mt-6 text-sm text-white/60">Sign in to manage releases, analytics and settings.</p>
        <button
          data-testid="google-login-button"
          onClick={handleLogin}
          className="mt-8 inline-flex w-full items-center justify-center gap-3 rounded-full bg-gold px-6 py-4 text-sm font-bold uppercase tracking-wide text-black transition-transform active:scale-95 hover:bg-gold-2"
        >
          <LogIn size={18} /> Continue with Google
        </button>
      </div>
    </div>
  );
}
